import noData from '../nodata/index.vue'
import swiperUnit from '../swiper-unit/index.vue'
import * as echarts from "echarts";
import {
  foodSafetyIndex
} from "@/api/master.js";
export default {
  name: "selfCheck",
  components: {
    swiperUnit,
    noData
  },
  data() {
    return {
      widthPix: 1,
      swiperIndex:0,
      dataTimer:null,
      safeCheckData:[
        [
          [
            {
              shopName:'念坚楼食堂',
              score:20,
              isActive:1,
              index:1,
            },
            {
              shopName:'知辛楼一楼食堂',
              score:20,
              isActive:1,
              index:2,
            },
            {
              shopName:'知辛楼二楼食堂',
              score:20,
              isActive:1,
              index:3,
            },
            {
              shopName:'爱苑二楼食堂',
              score:20,
              isActive:1,
              index:4,
            },
          ],
          [
            {
              shopName:'爱苑三楼食堂',
              score:20,
              isActive:1,
              index:5,
            },
            {
              shopName:'平苑二楼食堂',
              score:20,
              isActive:1,
              index:6,
            },
            {
              shopName:'仁苑一楼食堂',
              score:20,
              isActive:1,
              index:7,
            },
            {
              shopName:'平苑一楼食堂',
              score:20,
              isActive:1,
              index:8,
            },
          ]
        ],[
          [
            {
              shopName:'平苑三楼食堂',
              score:20,
              isActive:1,
              index:9
            },
            {
              shopName:'爱苑一楼食堂',
              score:20,
              isActive:1,
              index:10,
            },
            {
              shopName:'仁苑二楼食堂',
              score:20,
              isActive:1,
              index:11,
            },
            {
              shopName:'仁苑三楼食堂',
              score:20,
              isActive:1,
              index:12,
            },
          ],
          [
            {
              shopName:'义苑一楼食堂',
              score:20,
              isActive:1,
              index:13,
            },
            {
              shopName:'义苑二楼食堂',
              score:20,
              isActive:1,
              index:14,
            },
            {
              shopName:'义苑三楼食堂',
              score:20,
              isActive:1,
              index:15,
            },
            {
              shopName:'仁苑美食城',
              score:20,
              isActive:1,
              index:16,
            },
          ]
        ],
      ]
    };
  },

  props:{
    theme:{
      type:String,
    },
    componentName:{
      type:String,
    }
  },
  mounted() {
    this.widthPix =
      window.screen.width < 1920 ? 1 : Math.floor(window.screen.width / 1920);
       this.getFoodSafetyIndexData();
       this.dataTimer = setInterval(() => {
        this.getFoodSafetyIndexData();
       }, 300000);
   
  },
  destroyed() {
    if (this.dataTimer) {
      clearInterval(this.dataTimer);
      this.dataTimer = null;
    }
    if (this.shopIndexTimer) {
      clearInterval(this.shopIndexTimer);
      this.shopIndexTimer = null;
    }
  },
  methods: {
    handleChartClick(chartItem) {
      // 向父组件发送点击事件
      this.$emit('chart-click', {
        shopId: chartItem.shopId,
        shopName: chartItem.shopName
      });
    },
    handleSwiperChange(index){
      this.swiperIndex = index;
    },
    handleSwiperPrev(){
      this.$nextTick(() => {
        this.$refs.safeCheckSwiper.prev();
      });
    },
    handleSwiperNext(){
      this.$nextTick(() => {
        this.$refs.safeCheckSwiper.next();
      });
    },
    initSafeCheckChart(){
      this.$nextTick(()=>{
        this.safeCheckData.forEach(item => {
          item.forEach(chartData => {
            chartData.forEach(chartItem => {
              this.showChart('safe'+chartItem.index, chartItem);
            });
          });
        });
      })
    },
    getFoodSafetyIndexData() {
      foodSafetyIndex().then((res) => {
        console.log("res--foodSafetyIndex-191", res);
        let formattedData = [];
        let currentGroup = [];
        let currentRow = [];
        // 每6个店铺为一组,每行3个店铺
        res.forEach((item, index) => {
          item.index = index;
          currentRow.push({
            shopName: item.shopName || '东贝食堂',
            shopId: item.shopId,
            score: item.score || 0,
            isActive: item.isActive || 1,
            index: item.index
          });

          // 每3个店铺形成一行
          if(currentRow.length === 3 || index === res.length - 1) {
            currentGroup.push([...currentRow]);
            currentRow = [];
            
            // 每6个店铺(即2行)形成一组
            if(currentGroup.length === 2 || index === res.length - 1) {
              formattedData.push([...currentGroup]);
              currentGroup = [];
            }
          }
        });

        this.safeCheckData = formattedData;
        if (this.shopIndexTimer) {
          clearInterval(this.shopIndexTimer);
          this.shopIndexTimer = null;
        }
        this.initSafeCheckChart();
        this.shopIndexTimer = setInterval(() => {
          this.initSafeCheckChart();
        }, 60000);
      });
    },
    showChart(ref, data) {
      console.log(ref, data);
      try {
        let color = [];
        if(this.theme === 'blue'){
          color =
          data.score < 0
            ? ["#D85555", "#FFA66F"]
            : data.score >= 90
            ? ["#3FB5FF", "#3FB5FF"]
            : data.score >= 70
            ? ["#FFEB93", "#FF8C34"]
            : ["#D85555", "#FFA66F"]; 
        }else{
          color =
          data.score < 0
          ? ["#D85555", "#FFA66F"]
          : data.score >= 90
          ? ["#4FD169", "#AAEB7E"]
          : data.score >= 70
          ? ["#FFEB93", "#FF8C34"]
          : ["#D85555", "#FFA66F"]; 
        }
        
        const score = data.score;

        let img =
          "https://dobaycdn.anasit.com/dashboard_images/circle-bac.png"; //加载文件
        let option = {
          graphic: {
            // 这个属性可以在饼图内部填充图片,文字等
            elements: [
              {
                type: "image",
                style: {
                  image: img, //这里添加图片地址
                  width: 50 * this.widthPix,
                  height: 50 * this.widthPix,
                },
                left: "center", //
                top: "middle", //配置图片居中
              },
            ],
          },

          title: {
            text: data.isActive == 0 ? "未启用" : score,
            x: "center",
            y: "center",
            textStyle: {
              fontWeight: "normal",
              color: data.isActive == 0 ? "#BCD2ED" : "#fff",
              fontFamily: "DINCondensed-Bold-Bold",
              fontSize:
                data.isActive == 0 ? 9 * this.widthPix : 20 * this.widthPix,
            },
          },
          color: ["rgba(67, 96, 122, 0.6)"],

          series: [
            {
              name: "Line 1",
              type: "pie",
              clockWise: true,
              radius: ["86%", "100%"],
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              emphasis: {
                scale: false,
              },
              // hoverAnimation: false,
              data: [
                {
                  value: score < 0 ? 100 : score,
                  name: "01",
                  itemStyle: {
                    color: {
                      // 完成的圆环的颜色
                      colorStops: [
                        {
                          offset: 0,
                          color: color[0], // 0% 处的颜色
                        },
                        {
                          offset: 0.5,
                          color: color[0], // 0% 处的颜色
                        },
                        {
                          offset: 1,
                          color: color[1], // 100% 处的颜色
                        },
                      ],
                    },
                    label: {
                      show: false,
                    },
                    labelLine: {
                      show: false,
                    },
                  },
                },
                {
                  name: "02",
                  value: score < 0 ? 0 : 100 - score,
                },
              ],
            },
          ],
        };
        
        // 修复图表初始化
        let chart = this.$refs[ref];
        if (chart && chart[0]) { // 确保 ref 存在且是数组
          let myChart = echarts.init(chart[0]);
          option && myChart.setOption(option);
        } else {
          console.warn(`Chart element with ref ${ref} not found`);
        }
      } catch (error) {
        console.error(`Error initializing chart ${ref}:`, error);
      }
    },
  },
};
